import Text from 'components/Text';
import { fontSizes } from 'appconstants';
import { cn } from 'lib/utils';

interface DetailRowProps {
  label: string;
  value: string;
  valueClass?: string;
}

const DetailRow = ({ label, value, valueClass }: DetailRowProps) => {
  return (
    <div className='flex justify-between py-2.5 border-b last:border-b-0'>
      <Text text={label} size={fontSizes.h14} />
      <Text text={value} className={cn('text-muted-foreground', valueClass)} size={fontSizes.h14} />
    </div>
  );
};

export default DetailRow;